export enum ApiRequestStatus {
    /** Initial state before any API request is made */
    Idle = 'Idle',
    /** Request is currently in progress */
    Loading = 'Loading',
    /** Request completed successfully */
    Success = 'Success',
    /** Request failed with an error */
    Error = 'Error'
}

export enum DealershipPickerMode {
    DEFAULT = 'default',
    ALL_DEALERSHIPS = 'all_dealerships'
}
